
const LandscapingServices = () => {
  const services = [
    {
      icon: 'ri-plant-line',
      title: 'Garden Landscaping',
      description: 'Complete garden design and landscaping services to transform your outdoor space into a beautiful, functional area. From concept to completion, we create stunning gardens.',
      features: ['Custom garden design', 'Plant selection &amp; installation', 'Lawn establishment', 'Hardscaping features'],
    },
    {
      icon: 'ri-scissors-cut-line',
      title: 'Garden Clean-Ups',
      description: 'Comprehensive garden clean-up services to restore overgrown or neglected gardens. We remove weeds, trim plants, clear debris, and leave your garden looking pristine.',
      features: ['Weed removal', 'Plant trimming &amp; pruning', 'Debris clearing', 'Garden waste disposal'],
    },
    {
      icon: 'ri-tools-line',
      title: 'Garden Maintenance',
      description: 'Regular garden maintenance to keep your outdoor space looking its best year-round. Scheduled visits ensure your garden stays healthy, tidy, and beautiful.',
      features: ['Lawn mowing', 'Hedge trimming', 'Seasonal planting', 'Pest &amp; disease control'],
    },
    {
      icon: 'ri-seedling-line',
      title: 'Compost Supply &amp; Delivery',
      description: 'Quality compost and soil delivered to your property across Durban and KZN. Perfect for enriching garden beds, improving soil quality, and promoting healthy plant growth.',
      features: ['Premium quality compost', 'Various quantities available', 'Delivery across KZN', 'Soil improvement advice'],
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Irrigation Solutions',
      description: 'Efficient irrigation system installation and maintenance to keep your garden watered properly. Save water while ensuring your plants receive optimal hydration.',
      features: ['Drip irrigation systems', 'Sprinkler installation', 'Water-saving solutions', 'System maintenance'],
    },
    {
      icon: 'ri-recycle-line',
      title: 'Garden Waste Removal',
      description: 'Efficient removal and responsible disposal of all garden waste including branches, leaves, grass clippings, and general garden debris across Durban and surrounding areas.',
      features: ['All waste types', 'Eco-friendly disposal', 'Same-day service available', 'Competitive pricing'],
    },
  ];

  return (
    <div className="mb-16">
      <h2 className="font-serif text-4xl font-bold text-charcoal mb-4">
        Our Landscaping Services
      </h2>
      <p className="text-gray-600 text-lg mb-12 leading-relaxed">
        Look Who's Landscaping provides professional garden solutions for residential and commercial properties across KwaZulu-Natal. Our experienced team delivers quality workmanship, reliable service, and beautiful results that enhance your outdoor living space.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {services.map((service, index) => (
          <div key={index} className="bg-greenbg rounded-xl p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-start space-x-4">
              <div className="w-14 h-14 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${service.icon} text-white text-2xl w-7 h-7 flex items-center justify-center`}></i>
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-xl text-charcoal mb-2">{service.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-checkbox-circle-fill text-primary mr-2 w-4 h-4 flex items-center justify-center"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-primary/10 border-l-4 border-primary rounded-lg p-6">
        <h4 className="font-bold text-xl text-charcoal mb-3 flex items-center">
          <i className="ri-leaf-line text-primary mr-3 text-2xl w-6 h-6 flex items-center justify-center"></i>
          Eco-Friendly Practices
        </h4>
        <p className="text-gray-700 leading-relaxed">
          We're committed to environmentally responsible landscaping. Our services include water-wise plant selection, organic compost use, responsible waste disposal, and sustainable garden practices that benefit both your property and the environment.
        </p>
      </div>
    </div>
  );
};

export default LandscapingServices;
